import View from 'mixins/view';
import { siteModel } from 'models/SiteModel';
import AvatarView from '@ui/comments/avatar-view';

export const elements = {
    input: '.text-editor',
    form: 'form.c-comments__content',
    buttonsContainer: '.comment-textfield__btns',
    mainCommentInput: '.c-comments__main--editor .text-editor'
};

export default class extends View {
    constructor(model) {
        super(model);
        this.setRootEl($(`<div class="c-comments__main c-comments__main--editor"></div>`));
    }
    edit(model) {
        this.data = `data-id='${ model.get('id') }'`;
        this.textContent = model.get('textContent');
    }
    render() {
        const User = siteModel.get('User');
        const avatarView = new AvatarView(User);
        this.getRootEl().empty();
        this.addChild(avatarView);

        avatarView.render();
        this.getRootEl().append([
            avatarView.getRootEl(),
            $(`
                <form class="c-comments__content" action="#" ${ (this.data) ? this.data : '' }">
                    <div class="comment-textfield">
                        <div contenteditable class="text-editor text-editor--small" placeholder="${ $(elements.mainCommentInput).attr('placeholder') }">${ (this.textContent) ? this.textContent : '' }</div>
                        <div class="comment-textfield__btns"></div>
                        <div class="comment-custom-loader"></div>
                    </div>
                </form>
            `),
        ]);


        this.cancelButton = $('<button type="reset" class="c-comments__btn">Anuluj</button>');
        this.submitButton = $('<button type="button" class="c-comments__btn c-comments__btn--send">Zmień</button>');

        this.cancelButton.on('click', ::this.parentNode.setEditMode);

        this.getRootEl()
            .find(elements.buttonsContainer)
            .append([
                this.cancelButton,
                this.submitButton,
            ]);

    }
};



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/comments/edit-comment-view.js